<template>
    <div>
        <div :class="{ 'message': true, success: type === 'success', error: type === 'error', warning: type === 'warning', 'active': active }">
            {{ message }}
            <span @click="close" class="message-close" :data-tooltip="$t('label.close')">
                <i class="icon icon-close-large" aria-hidden="true"></i>
            </span>
        </div>
    </div>
</template>
<script>
    export default {
      name: 'MessageWidget',
      mounted () {
        this.$events.$on('message-open', eventData => this.open(eventData))
      },
      data () {
        return {
          active: false,
          message: '',
          type: ''
        }
      },
      methods: {
        open (eventData) {
          this.type = eventData.type
          this.message = eventData.message
          this.active = true

          setTimeout(function () { this.close() }.bind(this), 3000)
        },
        close () {
          this.active = false
          this.message = ''
          this.type = ''
        }
      },
      destroyed () {
        this.$events.$off('message-open')
      }
    }
</script>


// WEBPACK FOOTER //
// src/components/widgets/MessageWidget.vue